import type { DashboardConfig } from '#types/config/components/dashboard'

export default {
  showInterests: true
} satisfies DashboardConfig['profile']
